module.exports = __webpack_public_path__ + "static/a1-3e3401f1f4ded0258c0cc1a867ef65dc.png";